// extracted by mini-css-extract-plugin
export default {"HistorySelectStyle":"wiki-editor-active_HistorySelectStyle__4ctE7"};